import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

export default function NewHeader() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Function to check active link
  const isActive = (path) => location.pathname === path;

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo">
            <h1>Growboo</h1>
          </div>

          {/* Navigation */}
          <nav className={`nav ${isMobileMenuOpen ? "nav-open" : ""}`}>
            <Link
              to="/"
              className={`nav-link ${isActive("/") ? "active" : ""}`}
            >
              Home
            </Link>

            <Link
              to="/how-to-start"
              className={`nav-link ${
                isActive("/how-to-start") ? "active" : ""
              }`}
            >
              How To Start
            </Link>

            <Link
              to="/about"
              className={`nav-link ${isActive("/about") ? "active" : ""}`}
            >
              About Us
            </Link>

            <Link
              to="/contact"
              className={`nav-link ${isActive("/contact") ? "active" : ""}`}
            >
              Contact Us
            </Link>

            {/* <Link
              to="/news"
              className={`nav-link ${isActive("/news") ? "active" : ""}`}
            >
              News
            </Link> */}

            {/* Auth Buttons for Mobile */}
            <div className="auth-buttons-mobile">
              <Link to="/login" className="btn btn-login">
                Login
              </Link>
              <Link to="/join-us" className="btn btn-register">
                Join Us
              </Link>
            </div>
          </nav>

          {/* Auth Buttons for Desktop */}
          <div className="auth-buttons-desktop">
            <Link to="/login" className="btn btn-login">
              Login
            </Link>
            <Link to="/join-us" className="btn btn-register">
              Join Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
